import React from "react";

const ConfirmationPage = () => {
  return (
    <div className="wrapper_v2">
      <div class="boxWhite deleteSection success">
        <i class="material-symbols-rounded fill">check_circle</i>
        <h5>
          {" "}
          Your request saved successfully! Account will be deactivated within
          7-10 days
        </h5>
        <h6 style={{ marginLeft: "80px" }}>Hope to see you again</h6>
        {/* <div class="actionButtons">
        <button class="btn prim fullW ripple">Close this window</button>
      </div> */}
      </div>
    </div>
  );
};

export default ConfirmationPage;
